import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [ CommonModule ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  host: {
    '[class.lg:tw-col-span-2]': 'fullWidth',
    '[class.tw-h-full]': 'fullHeigth && !halfHeigth',
    '[class.tw-h-1/2]': 'halfHeigth',
    'class': 'tw-col-span-1 tw-block',
  }
})
export class CardComponent {
  @Input() cardTitle?: string;
  @Input() fullWidth: boolean = false;
  @Input() fullHeigth: boolean = true;
  @Input() halfHeigth: boolean = false;
  @Input() withCard: boolean = true;
}